import styles from "./Paragraph.module.css";

const Paragraph = ({ textParagraph }) => {
  return <p className={styles.containerText}>{textParagraph}</p>;
};

export default Paragraph;
